export var DEFAULT_COLOR = '#4fa94d';
export var DEFAULT_WAI_ARIA_ATTRIBUTE = {
    'aria-busy': true,
    role: 'status',
};
